import {
  Box,
  Button,
  ButtonBase,
  Drawer,
  Grid,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

const EmailCount = () => {
  const theme = useTheme();
  const { currentOrg } = useContext(OrganizationUserContext);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { setUpgradeDialogSource, subscription, plans, emailSents } =
    useContext(SubscriptionContext);

  if (
    !plans ||
    subscription?.isSubscribed ||
    currentOrg?.isBrand ||
    !subscription
  )
    return <></>;

  const getText = () => {
    if (emailSents > subscription?.monthlyLimit!) {
      return `${emailSents} emails`;
    }
    return `${emailSents}/${subscription?.monthlyLimit!} emails`;
  };

  const getValue = () => {
    if (emailSents > subscription?.monthlyLimit!) {
      return 100;
    }
    return (emailSents / subscription?.monthlyLimit!) * 100;
  };

  const renderDesktopView = () => {
    const overLimit = emailSents > subscription?.monthlyLimit!;
    return (
      <ButtonBase
        onClick={() =>
          setUpgradeDialogSource(
            UpgradeDialogSource.top_bar_emails_sent_progress,
          )
        }
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          lineHeight: 1.2,
          px: 0.5,
          py: 0.25,
          borderRadius: 1,
          "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
        }}
      >
        <Typography
          sx={{
            fontFamily: theme.typography.h6.fontFamily,
            color: "primary.main",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {overLimit
            ? `${emailSents}`
            : `${emailSents} / ${subscription?.monthlyLimit!}`}
        </Typography>
        <Typography
          sx={{ color: "text.secondary", fontSize: 11, lineHeight: 1.2 }}
        >
          emails this month
        </Typography>
      </ButtonBase>
    );
  };

  const renderMobileView = () => {
    return (
      <Drawer open={true} variant="permanent" anchor={"bottom"}>
        <Box
          sx={{ backgroundColor: "primary.main", p: 2 }}
          onClick={() => {
            setUpgradeDialogSource(
              UpgradeDialogSource.top_bar_emails_sent_progress,
            );
          }}
        >
          <LinearProgress
            variant="determinate"
            value={getValue()}
            sx={{
              borderRadius: 4,
              "& .MuiLinearProgress-bar": { backgroundColor: "yellow.main" },
            }}
          />

          <Grid
            container
            justifyContent="center"
            sx={{ mt: 1 }}
            alignItems={"center"}
            gap={1}
          >
            <Typography
              textAlign={"center"}
              sx={{ color: "white", fontSize: 10 }}
            >
              You've sent <strong>{getText()}</strong> this month.
            </Typography>
            <Button
              sx={{
                color: "yellow.main",
                fontSize: 10,
                borderRadius: 4,
                px: 1,
                border: "1px solid #FFFFAB",
              }}
              size="small"
            >
              Upgrade to send more
            </Button>
          </Grid>
        </Box>
      </Drawer>
    );
  };

  if (isSmallScreen) {
    return renderMobileView();
  } else {
    return renderDesktopView();
  }
};

export default EmailCount;
